angular.module('public').controller('SignInCtrl', ["$scope", function($scope) {
  $scope.params = {};
  $scope.data = {};
  return $scope.togglePassword = function() {
    return $scope.params.passwordVisible = !$scope.params.passwordVisible;
  };
}]);
